<template>
    <section class="7up7down Poker space-l" loading="lazy">
         <div class="container-fluid">
            <div class="row  no-gutters">
               <div class="col-md-4 col-12">
                  <h1 class="live-patti-header">
                    7up 7down
                  </h1>
                  <div class="teen-patti-img">
                     <img loading="lazy" src="@/assets/images/7up7down-menu.webp" alt="7up7down-menu">
                  </div>
               </div>
               <div class="col-md-8 col-12">
                  <div class="rules">
                    <h2 class="live-patti-header">
                        7:
                     </h2>
                     <div class="v-rules">
                        The drawn card should be 7's.
                     </div>
                     <h2 class="live-patti-header">
                        7 Down:
                     </h2>
                     <div class="v-rules">
                        The drawn card should be amount A's, 2's, 3's, 4's, 5's or 6's.
                     </div>
                     <h2 class="live-patti-header">
                        Red:
                     </h2>
                     <div class="v-rules">
                        The drawn card should be amount A's, 2's, 3's, 4's, 5's or 6's.
                     </div>
                     <h2 class="live-patti-header">
                        Black:
                     </h2>
                     <div class="v-rules">
                        The drawn card should be amount A's, 2's, 3's, 4's, 5's or 6's.
                     </div>
                     <h2 class="live-patti-header">
                        Even:
                     </h2>
                     <div class="v-rules">
                        The drawn card should be amount 2's, 4's, 6's, 8's, 10's or Q's.
                     </div>
                     <h2 class="live-patti-header">
                        Odd:
                     </h2>
                     <div class="v-rules">
                        The drawn card should be amount A's, 3's, 5's, 7's, 9's, 11's or 13's.
                     </div>
                     <h2 class="live-patti-header">
                        Club:
                     </h2>
                     <div class="v-rules">
                        The drawn card should be Club.
                     </div>
                     <h2 class="live-patti-header">
                        Diamond:
                     </h2>
                     <div class="v-rules">
                        The drawn card should be Diamond.
                     </div>
                     <h2 class="live-patti-header">
                        Heart:
                     </h2>
                     <div class="v-rules">
                        The drawn card should be Heart.
                     </div>
                     <h2 class="live-patti-header">
                        Spade:
                     </h2>
                     <div class="v-rules">
                        The drawn card should be Spade.
                     </div>
                 
                  </div>
               </div>
            </div>
         </div>
      </section>
</template>